import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissoesAcessoService } from '../permissoes-acesso.service';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { Usuario } from '../../comum/modelos/usuario';
import { UsuarioGrupoAcesso } from '../../comum/modelos/usuario-grupo-acesso';
import { UsuarioService } from '../../usuario/usuario.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-cadastro-usuario-grupo-acesso',
  templateUrl: './cadastro-usuario-grupo-acesso.component.html',
  styleUrls: ['./cadastro-usuario-grupo-acesso.component.css']
})
export class CadastroUsuarioGrupoAcessoComponent implements OnInit {

  usuarios: Usuario[];
  gruposAcessoUsuario: UsuarioGrupoAcesso[];
  idUsuario: number;

  MODO: string;
  CADASTRAR = 'Cadastrar';
  ATUALIZAR = 'Atualizar';
  statusCode: number;
  selecionados: boolean;

  public evento: Evento;
  public paginacao: Paginacao;

  public loading = false;

  constructor(
    private _permissoesAcessoService: PermissoesAcessoService,
    private _comumService: ComumService,
    private _usuarioService: UsuarioService,
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.usuarios = new Array<Usuario>();
    this.gruposAcessoUsuario = new Array<UsuarioGrupoAcesso>();
    this.evento = this._comumService.evento;
    this.paginacao = new Paginacao();
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;
    const idUsuario = this._activatedRoute.snapshot.params['id'];
    const self = this;

    if (idUsuario !== undefined) {
      this.idUsuario = idUsuario;
      forkJoin(
        this._usuarioService.obterUsuarioPorIdHttp(idUsuario),
        this._permissoesAcessoService.obterGruposAcessoHttp(parseInt(this._cookieService.get('idCliente'))),
        this._permissoesAcessoService.obterGruposAcessoUsuarioHttp(idUsuario))
        .subscribe(([usuario, gruposAcesso, gruposAcessoUsuario]) => {
          this.usuarios.push(usuario);
          for (const grupoAcesso of gruposAcesso) {
            const novoUsuarioGrupoAcesso = new UsuarioGrupoAcesso();
            novoUsuarioGrupoAcesso.grupoAcesso = grupoAcesso;
            novoUsuarioGrupoAcesso.idUsuario = idUsuario;
            for (const usuarioGrupoAcesso of gruposAcessoUsuario) {
              if (usuarioGrupoAcesso.grupoAcesso.idGrupoAcesso === grupoAcesso.idGrupoAcesso) {
                novoUsuarioGrupoAcesso.idUsuarioGrupoAcesso = usuarioGrupoAcesso.idUsuarioGrupoAcesso;
                novoUsuarioGrupoAcesso.selecionado = true;
                break;
              }
            }
            self.gruposAcessoUsuario.push(novoUsuarioGrupoAcesso);
          }
          this.MODO = this.ATUALIZAR;
          this.loading = false;
        });
    } else {
      forkJoin(
        this._usuarioService.obterUsuariosHttp(parseInt(this._cookieService.get('idCliente'))),
        this._permissoesAcessoService.obterGruposAcessoHttp(parseInt(this._cookieService.get('idCliente'))))
        .subscribe(([usuarios, gruposAcesso]) => {
          this.usuarios = usuarios;
          gruposAcesso.forEach(grupoAcesso => {
            const usuarioGrupoAcesso = new UsuarioGrupoAcesso();
            usuarioGrupoAcesso.grupoAcesso = grupoAcesso;
            self.gruposAcessoUsuario.push(usuarioGrupoAcesso);
          });
          this.MODO = this.CADASTRAR;
          this.loading = false;
        });
    }
  }

  onSubmit(): void {
    this.loading = true;
    const gruposAcessoUsuarioInsert = new Array<UsuarioGrupoAcesso>();
    const grupoAcessoUsuarioRemove = new Array<UsuarioGrupoAcesso>();

    this.gruposAcessoUsuario.forEach(usuarioGrupoAcesso => {
      if (usuarioGrupoAcesso.idUsuario === undefined) {
        usuarioGrupoAcesso.idUsuario = this.idUsuario;
      }
      if (!usuarioGrupoAcesso.selecionado && usuarioGrupoAcesso.idUsuarioGrupoAcesso !== undefined && usuarioGrupoAcesso.alterado) {
        grupoAcessoUsuarioRemove.push(usuarioGrupoAcesso);
      } else if (usuarioGrupoAcesso.selecionado && usuarioGrupoAcesso.idUsuarioGrupoAcesso === undefined
        && usuarioGrupoAcesso.alterado) {
        gruposAcessoUsuarioInsert.push(usuarioGrupoAcesso);
      }
    });
    if (grupoAcessoUsuarioRemove.length > 0) {
      this._permissoesAcessoService.apagarGruposAcessoUsuarioHttp(grupoAcessoUsuarioRemove)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['permissoes']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    if (gruposAcessoUsuarioInsert.length > 0) {
      this._permissoesAcessoService.cadastrarGruposAcessoUsuarioHttp(gruposAcessoUsuarioInsert)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['permissoes']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
  }

  selecionar(usuarioGrupoAcesso: UsuarioGrupoAcesso): void {
    usuarioGrupoAcesso.selecionado = !usuarioGrupoAcesso.selecionado;
    usuarioGrupoAcesso.alterado = true;
  }

  selecionarTodos(): void {
    this.selecionados = !this.selecionados;
    this.gruposAcessoUsuario.forEach(grupoAcessoUsuario => {
      grupoAcessoUsuario.selecionado = this.selecionados;
      grupoAcessoUsuario.alterado = true;
    });
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/permissoes-acesso/cadastro-usuario-grupo-acesso/cadastro-usuario-grupo-acesso.component.ts